<template>
    <div class="tw-w-full tw-mx-auto 3xl:tw-max-w-screen-3xl 4xl:tw-max-w-screen-4xl tw-px-4 md:tw-px-8">
        <div class="tw-flex tw-items-center tw-mb-6">
            <h2 class="heading sans dark:tw-text-white">
                Upcoming Coaches
            </h2>
        </div>
        <!-- Upcoming Coaches -->
        <div class="tw-my-3">
            <div class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-5 tw-gap-3">
                <div v-for="coach in upcomingCoaches" class="tw-rounded-3xl tw-overflow-hidden tw-relative tw-flex tw-mb-3">
                    <!-- Coach Image -->
                    <img :src="`https://www.musora.com/cdn-cgi/image/width=300,height=436,quality=95/${coach['image']}`"
                         class="tw-w-full tw-flex tw-object-top tw-object-cover tw-filter tw-grayscale tw-transition-opacity tw-opacity-0"
                         :alt="`${coach['name']} Card`"
                         loading="lazy"
                         onload="this.classList.remove('tw-opacity-0')"
                    >
                    <div v-if="coach['date']" class="tw-absolute tw-leading-none tw-uppercase tw-rounded tw-p-1 tw-m-4 tw-bg-yellow-400">
                        <span class="tw-text-sm tw-text-[#00101D] tw-leading-none tw-font-bebas-neue">
                            <!-- Lock Icon SVG-->
                            <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.14286 4.375H6.71429V2.96875C6.71429 1.33203 5.49643 0 4 0C2.50357 0 1.28571 1.33203 1.28571 2.96875V4.375H0.857143C0.383929 4.375 0 4.79492 0 5.3125V9.0625C0 9.58008 0.383929 10 0.857143 10H7.14286C7.61607 10 8 9.58008 8 9.0625V5.3125C8 4.79492 7.61607 4.375 7.14286 4.375ZM5.28571 4.375H2.71429V2.96875C2.71429 2.19336 3.29107 1.5625 4 1.5625C4.70893 1.5625 5.28571 2.19336 5.28571 2.96875V4.375Z" fill="black"/>
                            </svg>
                            {{ coach['date'] }}
                        </span>
                    </div>
                    <div class="tw-absolute tw-w-full tw-left-0 tw-bottom-0 tw-text-white tw-flex tw-flex-col tw-text-center tw-uppercase tw-h-2/3 tw-px-3"
                         style="background: linear-gradient(180deg, rgba(1, 5, 15, 0) 0%, #01050F 100%);">
                        <!-- Coach Name -->
                        <p class="tw-text-2xl xl:tw-text-3xl tw-font-bebas-neue tw-break-words tw-flex tw-flex-col tw-mt-auto tw-mb-4"
                           style="line-height:1.1 !important; hyphens: auto;">
                            <span class="tw-block">{{ firstName(coach['name']) }}</span>
                            {{ lastName(coach['name']) }}
                        </p>

                        <!-- Coach Title -->
                        <p class="tw-text-sm tw-font-primary tw-text-yellow-400 tw-mb-8 tw-leading-snug" v-text="coach['focus_text']"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

const props = defineProps({
    upcomingCoaches: {
        type: Array,
        default: () => [],
    },
})

const fullNameWithoutTags = (name) => {
    return name.replace(/(<([^>]+)>)/ig, '');
}

const firstName = (name) => {
    const fullName = fullNameWithoutTags(name);
    return fullName.split(' ')[0];
}

const lastName = (name) => {
    const fullName = fullNameWithoutTags(name);
    return fullName.split(' ').slice(1).join(' ');
}
</script>
